module.exports = __webpack_public_path__ + "static/media/Cheese.6f3e1d39.svg";